import auth from './auth.json'
import buttons from './buttons.json'
import common from './common.json'
import country from './country.json'
import enums from './enums.json'
import errorMessages from './errorMessages.json'
import guaranteeOrder from './guaranteeOrder.json'
import layout from './layout.json'
import modal from './modal.json'
import pages from './pages.json'
import roleGuard from './roleGuard.json'
import setting from './setting.json'
import toast from './toast.json'
import validationMessages from './validationMessages.json'

export const PL = {
    auth,
    common,
    country,
    enums,
    errorMessages,
    guaranteeOrder,
    layout,
    modal,
    pages,
    roleGuard,
    toast,
    validationMessages,
    buttons,
    setting
}
